import Vue from "vue";
import Router from "vue-router";

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);
import reg from '@/components/login/reg'
import getPass from '@/components/login/getPass'
// import LoginSignOUT from '@/components/login/LoginSignOUT'
import signOutSuccess from '@/components/login/signOutSuccess'
import offprint from '@/components/login/offprint'
const router = new Router({
    mode: "history",
    routes: [{
        path: "/",
        name: "personal",
        redirect: '/personal',
        meta: {
            hideHead: true,
            mobileHead: true,
            paddingBottom: false
        },
        // component: resolve => require(["@/pages/personal/index"], resolve)
    },
    {
        path: "/reg",
        name: "reg",
        meta: {
            hideHead: true,
            mobileHead: true,
            mobileFooter: true,
            paddingBottom: true
        },
        component: reg
    },
    {
        path: "/loginOut",
        name: "loginOut",
        meta: {
            hideHead: true,
            mobileHead: false,
            mobileFooter: false,
            paddingBottom: true
        },
        component: resolve => require(["@/components/login/loginOut"], resolve)
    },
    {
        path: "/addT",
        name: "addT",
        component: resolve => require(["@/pages/addTestLogin"], resolve)
    },
    {
        path: "/getPass",
        name: "getPass",
        meta: {
            hideHead: true,
            mobileHead: true,
            mobileFooter: true,
            paddingBottom: true
        },
        component: getPass
    },
    {
      path: "/LoginSignOUT",
      name: "LoginSignOUT",
      meta: {
          hideHead: true,
          mobileHead: true,
          mobileFooter: true,
          paddingBottom: true
      },
      component: resolve => require(["@/components/login/LoginSignOUT"], resolve)
      
      // component: LoginSignOUT
  },
  {
    path: "/preRegistration",
    name: "preRegistration",
    meta: {
        hideHead: true,
        mobileHead: true,
        mobileFooter: true,
        paddingBottom: true
    },
    component: resolve => require(["@/components/login/preRegistration"], resolve)
    
    // component: LoginSignOUT
},
    {
      path: "/signOutSuccess",
      name: "signOutSuccess",
      meta: {
          hideHead: false,
          mobileHead: true,
          mobileFooter: true,
          paddingBottom: true
      },
      component: signOutSuccess
  },
  {
    path: "/offprint",
    name: "offprint",
    meta: {
        hideHead: false,
        mobileHead: true,
        mobileFooter: true,
        paddingBottom: true
    },
    component: offprint
},
  
    {
        path: "/personal",
        name: "personal",
        component: resolve => require(["@/pages/personal/index"], resolve),
    },
    //支付宝支付页
    {
      path: "/paymentNew",
      name: "paymentNew",
      component: resolve => require(["@/pages/pubPayment/PaymentNew"], resolve),
      meta: {
          allowBack: false,
          mobileHead: false,
          hideHead: true,

      }
  },
  //支付成功
  {
    path: "/PaymentSuccess",
    name: "PaymentSuccess",
    component: resolve => require(["@/pages/pubPayment/PaymentSuccess"], resolve),
    meta: {
        allowBack: false,
        mobileHead: false,
        hideHead: true,

    }
},
    //第三方支付页（采编公共支付页）
    {
        path: "/payment",
        name: "payment",
        component: resolve => require(["@/pages/pubPayment/Payment"], resolve),
        meta: {
            allowBack: false,
            mobileHead: false,
            hideHead: true,

        }
    },

    //个人中心支付页
    {
        path: "/PersonalPayment",
        name: "PersonalPayment",
        component: resolve => require(["@/components/payment/Personalment"], resolve),
        meta: {
            allowBack: false,
            mobileHead: false,
            hideHead: true,

        }
    },
    //第三方扫码支付（采编公共支付页）
    {
        path: "/wechatPay",
        name: "wechatPay",
        component: resolve => require(["@/pages/pubPayment/PayScanCode"], resolve),
        meta: {
            allowBack: false,
            mobileHead: false,
            hideHead: true,

        }
    },
    //个人中心扫码支付
    {
        path: "/PersonalWechatPay",
        name: "PersonalWechatPay",
        component: resolve => require(["@/components/payment/indexNew"], resolve),
        meta: {
            allowBack: false,
            mobileHead: false,
            hideHead: true,
            paddingBottom: true,

        }
    },
    // c端商品库
    {
        path: "/Commodity",
        name: "Commodity",
        component: resolve =>
            require(["@/components/C-end-Commodity-Manage/index"], resolve)
    },
    // 退出
    {
        path: "/Exitsuccessful",
        name: "Exitsuccessful",
        component: resolve =>
            require(["@/components/login/Exitsuccessful"], resolve)
    },
    // 第三方登录
    {
        path: "/thirdLogin",
        name: "thirdLogin",
        meta: {
            hideHead: true,
            mobileHead: true,
            paddingBottom: true,
            mobileFooter: true

        },
        component: resolve => require(["@/pages/thirdLogin/index"], resolve)
    },
    // 期刊登录
    {
      path: "/qkLogin",
      name: "qkLogin",
      meta: {
          hideHead: true,
          mobileHead: true,
          paddingBottom: true,
          mobileFooter: true

      },
      component: resolve => require(["@/components/login/loginNew"], resolve)
  },
    {
        path: "/thirdLoginPage",
        name: "thirdLoginPage",
        meta: {
            hideHead: true,
            mobileHead: true,
            paddingBottom: true,
            mobileFooter: true

        },
        component: resolve => require(["@/pages/thirdLogin/login"], resolve)
    }
    ]
});

// router.onError((error) => {
//     const pattern = /Loading chunk (\d)+ failed/g;
//     const isChunkLoadFailed = error.message.match(pattern);
//     const targetPath = router.history.pending.fullPath;
//     console.log(targetPath)
//     if (isChunkLoadFailed) {
//         router.replace(targetPath);
//     }
// });

// 登录 路由拦截器
// router.beforeEach

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js